<swiper 
    class="swiper-container" 
    [config]="config" 
    [(index)]="index" 
    (indexChange)="onIndexChange($event)"
    (reachEnd)="onReachEnd()">
    <ng-content></ng-content>
</swiper>